<script>
import Swiper from '@/components/molecules/Swiper'
import recommendation from '@/modules/mixins/recommendation'

export default {
    name: 'Recommender',

    components: {
        Swiper,
    },

    mixins: [recommendation],
}
</script>

<template lang="pug">
.recommender(v-if="enabled && recommendations.length" :class="{'card p-6': card}")
    swiper(top-nav :update="recommendations.length" )
        template(v-slot:title)
          slot(name="title") {{ $t('cart.recommendation') }}
        recommendation(
            v-for="(recommendation, index) in recommendations"
            :key="`recommendation-${index}`" 
            :model="recommendation"
            @open="openMealSelector"
            @select="selectMeal")
</template>
